export default __webpack_public_path__ + "static/media/MX-Order-Hero-Desktop.8457f436.jpg";